import React from "react";
import { useSelector } from "react-redux";
import NoRecord from "../../../components/other/NoRecord";

const PartnerList = () => {
  const { partnersList } = useSelector((state) => state.moreReducer);
  return (
    <div class="untree_co-section product-section py-5">
      <div class="container">
        <div class="row">
          {partnersList?.length > 0 ? (
            partnersList.map((partner, index) => (
              <div class=" col-lg-3 col-md-6 mb-4">
                <div class="ct_links_card">
                  <a href={partner?.web_link} target="__blank">
                    <img src={partner?.company_image} alt="" />
                  </a>
                  <h4 class="mb-0">{partner?.company_title ?? ""}</h4>
                </div>
              </div>
            ))
          ) : (
            <NoRecord />
          )}
        </div>
      </div>
    </div>
  );
};

export default PartnerList;
